import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid, Typography, Box } from "@mui/material";
import { useDataProvider, Loading } from "react-admin";

interface TicketSummaryMetrics {
  newTickets: number;
  openTickets: number;
  slaBreached: number;
  closedTickets: number;
  archivedTickets: number;
  rejectedTickets: number;
}

const RmfTicketSummaryCards: React.FC = () => {
  const dataProvider = useDataProvider();
  const [metrics, setMetrics] = useState<TicketSummaryMetrics | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    setMetrics(null);
    setError(null);

    const fetchData = async () => {
      try {
        const response = await dataProvider.getChart(
          "rmf/analytics/ticket-summary-metrics",
          {}
        );
        if (!isMounted) return;
        setMetrics(response as TicketSummaryMetrics);
      } catch (e: any) {
        if (!isMounted) return;
        setError(e?.message || "Failed to load ticket summary metrics");
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [dataProvider]);

  if (error) {
    return (
      <Typography color="error" variant="body2">
        {error}
      </Typography>
    );
  }

  if (!metrics) {
    return <Loading />;
  }

  const items = [
    { label: "New", value: metrics.newTickets },
    { label: "Open", value: metrics.openTickets },
    { label: "Expired", value: metrics.slaBreached },
    { label: "Closed", value: metrics.closedTickets },
    { label: "Archived", value: metrics.archivedTickets },
    { label: "Rejected", value: metrics.rejectedTickets },
  ];

  return (
    <Grid container spacing={1}>
      {items.map((item) => (
        <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4, xl: 4 }} key={item.label}>
          <Card>
            <CardContent
              style={{
                padding: ".5em",
                height: "145px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="subtitle2"
                color="textSecondary"
                fontSize={"1.2em"}
                align="center"
                style={{ padding: "0" }}
              >
                {item.label}
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h4" align="center">
                  {item.value}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default RmfTicketSummaryCards;
